import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'
import {setAusbildungsplan, getAusbildungsplan} from '#services/storage'

export function pending(state) {
  return {
    ...state,
  }
}

export function fulfilled(state, payload) {
  return {
    ...state,
  }
}

export function rejected(state) {
  return {
    ...state,
  }
}

export async function action(payload) {
  try {
    const aubildungsplan = await getAusbildungsplan(payload.ausbildungsplanId)
    if (aubildungsplan !== null) {
      return {ausbildungsplan: aubildungsplan}
    }
    const result = await Api.getAusbildungsplan(payload.ausbildungsplanId)
    setAusbildungsplan(result.ausbildungsplan, payload.ausbildungsplanId)
    return result
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
